export function Wordmark({ className = "", size = "text-xl" }) {
  return (
    <span className={`${size} tracking-tight leading-none whitespace-nowrap ${className}`} aria-label="Write My Story">
      <span className="font-serif text-charcoal">Write</span>
      <span className="font-script text-gold mx-1 relative -top-[1px]" style={{ fontSize: "1.15em" }}>My</span>
      <span className="font-serif text-charcoal">Story</span>
    </span>
  );
}
